var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEtPrjAtivoB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49C38.531 49 49.5 38.031 49.5 24.5C49.5 10.969 38.531 0 25 0C11.469 0 0.5 10.969 0.5 24.5C0.5 38.031 11.469 49 25 49Z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.275 35.2C18.275 34.7582 18.6332 34.4 19.075 34.4H22.4249C22.8668 34.4 23.2249 34.7582 23.2249 35.2C23.2249 35.6418 22.8668 36 22.4249 36H19.075C18.6332 36 18.275 35.6418 18.275 35.2ZM17.45 32.8C17.45 32.3582 17.8082 32 18.25 32H23.2499C23.6918 32 24.0499 32.3582 24.0499 32.8C24.0499 33.2418 23.6918 33.6 23.2499 33.6H18.25C17.8082 33.6 17.45 33.2418 17.45 32.8ZM26.5981 14.3345C25.0477 12.829 22.9707 12 20.75 12C19.6658 11.9975 18.5919 12.2027 17.5898 12.6039C16.5877 13.005 15.6772 13.5942 14.9106 14.3376C14.144 15.0809 13.5364 15.9639 13.1227 16.9356C12.7091 17.9073 12.4974 18.9487 12.5 20C12.5 22.331 13.4214 24.5115 15.0266 25.982L15.2514 26.1865C16.18 27.0285 17.45 28.182 17.45 29.2V31.2H19.925V24.6555L18.4445 23.8414C18.0176 23.6066 17.8917 23.0516 18.1757 22.6557C18.4105 22.3284 18.8496 22.2225 19.2078 22.4067L20.75 23.2L22.2727 22.3993C22.623 22.2151 23.055 22.31 23.2958 22.624C23.596 23.0154 23.4812 23.5818 23.0523 23.8254L21.575 24.6645V31.2H24.0499V29.2C24.0499 28.206 25.306 27.0535 26.2233 26.2115L26.4764 25.9785C28.1275 24.45 28.9999 22.3805 28.9999 20C29.0054 18.9486 28.7959 17.9066 28.3837 16.9342C27.9714 15.9618 27.3646 15.0782 26.5981 14.3345Z",
    fill: "#4D78AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3257 33.8014C30.3257 34.0923 30.5615 34.3281 30.8524 34.3281H33.3476C33.6385 34.3281 33.8743 34.0923 33.8743 33.8014V29.5967H35.4652C35.9345 29.5967 36.1695 29.0294 35.8377 28.6976L32.4724 25.3324C32.2668 25.1267 31.9333 25.1267 31.7276 25.3324L28.3624 28.6976C28.0306 29.0294 28.2655 29.5967 28.7348 29.5967H30.3257V33.8014Z",
    fill: "#4D78AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEtPrjAtivoB);
export default __webpack_public_path__ + "static/media/IconEtPrjAtivoB.7d7cd03a000ac3bb25fde976b1128d70.svg";
export { ForwardRef as ReactComponent };